import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import { 
  REMOVE_TRADE_HISTORY_ITEM,
  SET_TRADE_HISTORY_INFO,
  NOTI_TIMEOUT,
  BASE_URL,
  UPDATE_TRADE_HISTORY_INPUT
} from './types';

export function getTradeHistoryInfo({ portfolioId }) {
  const url = `${BASE_URL()}/api/gettradehistoryinfo`;
  const request = axios.post(url, { portfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    dispatch(setTradeHistoryInfo([]));
    request.then((response) => {
      dispatch(setTradeHistoryInfo(response.data));      
    }).catch(() => {
      NotificationManager.error(`There was an error retrieving trade history information. Please refresh the page.`, 'Error!', NOTI_TIMEOUT);              
    });
  }
}

export function clearTradeHistory({ portfolioId }) {
  const url = `${BASE_URL()}/api/cleartradehistory`;
  const request = axios.post(url, { portfolioId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then((response) => {
      dispatch(setTradeHistoryInfo(response.data));      
    }).catch(() => {
      NotificationManager.error(`There was an error clearing trade history. Please try again.`, 'Error!', NOTI_TIMEOUT);              
    });
  }
}

export function removeTradeHistory({ tradeHistoryId }) {
  const url = `${BASE_URL()}/api/removetradehistory`;
  const request = axios.post(url, { tradeHistoryId }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then((response) => {
      dispatch({ type: REMOVE_TRADE_HISTORY_ITEM, payload: tradeHistoryId });
    }).catch(() => {
      NotificationManager.error(`There was an error removing from trade history. Please try again.`, 'Error!', NOTI_TIMEOUT);              
    });
  }
}

export function addTradeHistory({ portfolioId, symbol, buyPrice, sellPrice, tradeType, tradeDate }) {
  const url = `${BASE_URL()}/api/addtradehistory`;
  const request = axios.post(url, { portfolioId, symbol, buyPrice, sellPrice, tradeType, tradeDate }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then((response) => {
      dispatch(setTradeHistoryInfo(response.data));      
    }).catch(() => {
      NotificationManager.error(`There was an error adding to trade history. Please try again.`, 'Error!', NOTI_TIMEOUT);              
    });
  }
}

function setTradeHistoryInfo(payload) {
  return {
    type: SET_TRADE_HISTORY_INFO,
    payload: payload
  };
}

export function updateDbTradeHistoryInput({ tradeId, name, value }) {
  const url = `${BASE_URL()}/api/updatetradehistoryinput`;
  const request = axios.patch(url, { tradeId, name, value }, {
    headers: { authorization: localStorage.getItem('token') }
  });
  return (dispatch) => {
    request.then(() => {}).catch(() => {});
  }
}

export function updateTradeHistoryInput(payload) {
  return {
    type: UPDATE_TRADE_HISTORY_INPUT,
    payload: payload
  };
}
